import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  TimePicker,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { createQuiz } from "redux/actions/Quiz";
import { getAllCourses } from "redux/actions/Products";
import { getVideoContent, setCourseId } from "redux/actions";

const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const widthFull = { width: "100%" };

function AddQuiz({ closeModel }) {
  const [questionRandom, setQuestionRandom] = useState(true);
  const [answerRandom, setAnswerRandom] = useState(true);
  const [emailUser, setEmailUser] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = useForm();

  const dispatch = useDispatch();
  const { courses } = useSelector(({ products }) => products);
  const { videoContent } = useSelector(({ videoContent }) => videoContent);

  useEffect(() => {
    dispatch(getAllCourses());
  }, [dispatch]);

  const onCreateQuiz = async (values) => {
    setIsLoading(() => true);
    const payload = {
      quizType: values?.module ? "module" : "course",
      courseId: values?.course ? values?.course : null,
      moduleId: values?.module ? values?.module : null,
      releaseSchedule: values.release_on_type,
      numbersOfDaysToRelease: values.numbersOfDaysToRelease,
      releaseDate: values.releaseDate,
      prerequisits: values.prerequisite,
      passingPercentage: values.passing_score,
      repetations: values.repetations,
      completionTime: selectedTime,
      randomQuestions: values.is_question_random,
      randomAnswers: values.is_answer_random,
      questionPerPage: values.questionPerPage,
      emailNotification: values.email_to_user,
    };
    const outputArray = values.questions.map((item) => {
      const outputItem = {
        questionType: item.questionType,
        question: item.question,
        questionPoints: 1, // Default to 1 since points are removed
        answers: [],
      };

      if (item.questionType === "YES_NO") {
        // Explicitly handle yes/no answers
        const isYes = item.answer.toLowerCase() === "yes";
        outputItem.answers = [
          { answerText: "yes", isCorrect: isYes },
          { answerText: "no", isCorrect: !isYes },
        ];
      } else if (item.questionType === "MULTIPLE_CHOICE" && item.options) {
        for (const key in item.options) {
          const option = item.options[key];
          outputItem.answers.push({
            answerText: option,
            isCorrect: key == item.answer,
          });
        }
      } else if (item.questionType === "OPEN_ENDED") {
        outputItem.answers.push({
          answerText: item.answer,
          isCorrect: true,
        });
      }

      // Log the question and its answers for debugging
      // console.log("Processing question:", {
      //   question: item.question,
      //   type: item.questionType,
      //   selectedAnswer: item.answer,
      //   processedAnswers: outputItem.answers,
      // });

      return outputItem;
    });
    payload.data = outputArray;
    try {
      await dispatch(createQuiz(payload, closeModel));
      setIsLoading(false);
    } catch (error) {
      console.error("Error creating quiz:", error);
      setIsLoading(false);
    }
  };

  const changeRadio = (e, cb) => {
    cb(e.target.value);
  };

  const handleCourseChange = (id) => {
    dispatch(setCourseId(id));
    dispatch(getVideoContent());
    form.resetFields(["module"]);
  };

  const handleTimeChange = (time, timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    setSelectedTime(hours * 3600 + minutes * 60 + seconds);
  };

  const onFinishFailed = (errorInfo) => {
    const errorFields = errorInfo.errorFields;
    if (errorFields.length > 0) {
      form.scrollToField(errorFields[0].name[0]);
    }
  };

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onCreateQuiz}
        onFinishFailed={onFinishFailed}
        name="create_quiz"
        initialValues={{
          prerequisite: "None",
          passing_score: 50,
          is_question_random: questionRandom,
          is_answer_random: answerRandom,
          email_to_user: emailUser,
        }}
      >
        <Form.Item name="course" label="Course" rules={[{ required: true }]}>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            onChange={handleCourseChange}
          >
            {courses &&
              courses.map((ct) => {
                return <Select.Option key={ct._id}>{ct.title}</Select.Option>;
              })}
          </Select>
        </Form.Item>

        <Form.Item name="module" label="Module">
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            placeholder="Please select"
            allowClear
            optionFilterProp="children"
          >
            {videoContent &&
              videoContent.map((ct) => {
                return (
                  <Select.Option key={ct} value={ct._id}>
                    {ct.title}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>

        <Form.Item
          name="release_on_type"
          label="Release on"
          rules={[{ required: true, message: "Please select release time" }]}
        >
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            getPopupContainer={() => document.getElementById("create_quiz")}
          >
            {["Immediately", "Days after enrollment", "Date"].map((ct) => {
              return <Select.Option key={ct}>{ct}</Select.Option>;
            })}
          </Select>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.release_on_type !== curr.release_on_type
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("release_on_type") === "Date" ? (
              <Form.Item
                name="releaseDate"
                label="Release Date"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        value === undefined &&
                        getFieldValue("release_on_type") === "Date"
                      ) {
                        return Promise.reject("Release date is required");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  style={{
                    width: "100%",
                  }}
                  disabledDate={(current) =>
                    current.isBefore(moment().subtract(1, "day"))
                  }
                />
              </Form.Item>
            ) : getFieldValue("release_on_type") === "Days after enrollment" ? (
              <Form.Item
                name="numbersOfDaysToRelease"
                label="Days After Enrollment"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        value === undefined &&
                        getFieldValue("release_on_type") ===
                          "Days after enrollment"
                      ) {
                        return Promise.reject(
                          "Days After Enrollment is required"
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <InputNumber
                  style={{
                    width: "100%",
                  }}
                />
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item name="prerequisite" label="Prerequisite">
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Please select"
            getPopupContainer={() => document.getElementById("create_quiz")}
          >
            {["None", "Course completion"].map((ct) => {
              return <Select.Option key={ct}>{ct}</Select.Option>;
            })}
          </Select>
        </Form.Item>

        <Form.Item
          name="passing_score"
          label="Passing Score(%)"
          rules={[{ required: true, message: "Please add passing score" }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="questionPerPage"
          label="question Per Page"
          rules={[{ required: true, message: "Please add question per page" }]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.restriction_on_repetition !== curr.restriction_on_repetition
          }
        >
          <Form.Item name="repetations" label="Number of attempts">
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Form.Item>

        <Form.Item
          name="auto_submit_after"
          label="Auto Submit After"
          handleTimeChange
          rules={[
            { required: true, message: "Please select auto submit time" },
          ]}
        >
          <TimePicker
            style={{ width: "100%" }}
            format={"HH:mm:ss"}
            onChange={handleTimeChange}
          />
        </Form.Item>

        <Form.Item name="is_question_random" label="Randomize questions?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setQuestionRandom)}
            value={questionRandom}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="is_answer_random" label="Randomize answers?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setAnswerRandom)}
            value={answerRandom}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item name="email_to_user" label="Email notification to user?">
          <Radio.Group
            onChange={(e) => changeRadio(e, setEmailUser)}
            value={emailUser}
          >
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.List
          name="questions"
          rules={[
            {
              validator: async (_, questions) => {
                if (!questions || questions.length < 1) {
                  return Promise.reject(
                    new Error("At least 1 questions required")
                  );
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <>
                  <Row gutter={16}>
                    <Col className="gutter-row" span={19}>
                      <Form.Item
                        label="Question"
                        name={[name, "question"]}
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea />
                      </Form.Item>
                      {/* <Form.Item
                        label="Question points"
                        name={[name, "questionPoints"]}
                        rules={[{ required: true }]}
                      >
                        <InputNumber min={1} style={{ width: "100%" }} />
                      </Form.Item> */}

                      <Form.Item
                        label="Question Type"
                        name={[name, "questionType"]}
                        rules={[{ required: true }]}
                      >
                        <Select
                          style={{
                            width: "100%",
                          }}
                          showSearch
                          allowClear
                          optionFilterProp="children"
                          placeholder="Please select"
                          getPopupContainer={() =>
                            document.getElementById("create_quiz")
                          }
                        >
                          {["YES_NO", "MULTIPLE_CHOICE", "OPEN_ENDED"].map(
                            (ct) => {
                              return (
                                <Select.Option key={ct}>{ct}</Select.Option>
                              );
                            }
                          )}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        noStyle
                        shouldUpdate={(prev, curr) => {
                          return (
                            prev.questions[index]?.questionType !==
                            curr.questions[index]?.questionType
                          );
                        }}
                      >
                        {({ getFieldValue }) =>
                          getFieldValue([
                            "questions",
                            index,
                            "questionType",
                          ]) === "YES_NO" ? (
                            <Form.Item
                              label="Answer"
                              name={[name, "answer"]}
                              rules={[{ required: true }]}
                            >
                              <Select
                                style={{
                                  width: "100%",
                                }}
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                placeholder="Please select"
                                getPopupContainer={() =>
                                  document.getElementById("create_quiz")
                                }
                              >
                                {["yes", "no"].map((ct) => {
                                  return (
                                    <Select.Option key={ct}>{ct}</Select.Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          ) : getFieldValue([
                              "questions",
                              index,
                              "questionType",
                            ]) === "OPEN_ENDED" ? (
                            <Form.Item
                              label="Answer"
                              name={[name, "answer"]}
                              rules={[{ required: true }]}
                            >
                              <Input.TextArea />
                            </Form.Item>
                          ) : getFieldValue([
                              "questions",
                              index,
                              "questionType",
                            ]) === "MULTIPLE_CHOICE" ? (
                            <>
                              {["1", "2", "3", "4"].map((item) => {
                                return (
                                  <Form.Item
                                    label={`option ${item}`}
                                    name={[name, "options", item]}
                                    rules={[{ required: true }]}
                                  >
                                    <Input.TextArea />
                                  </Form.Item>
                                );
                              })}
                              <Form.Item
                                label="Answer"
                                name={[name, "answer"]}
                                rules={[{ required: true }]}
                              >
                                <Select
                                  style={{
                                    width: "100%",
                                  }}
                                  showSearch
                                  allowClear
                                  optionFilterProp="children"
                                  placeholder="Please select"
                                  getPopupContainer={() =>
                                    document.getElementById("create_quiz")
                                  }
                                >
                                  {[
                                    "option1",
                                    "option2",
                                    "option3",
                                    "option4",
                                  ].map((ct, i) => {
                                    return (
                                      <Select.Option key={ct} value={i + 1}>
                                        {ct}
                                      </Select.Option>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                            </>
                          ) : null
                        }
                      </Form.Item>
                    </Col>
                    <Col
                      className="gutter-row"
                      span={5}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        icon={<MinusCircleOutlined />}
                        onClick={() => remove(name)}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                </>
              ))}

              <Form.Item
                style={{ width: "100%", margin: "0 auto" }}
                wrapperCol={{ span: 16, offset: 4 }}
                labelCol={{ span: 0 }}
              >
                <Button
                  style={{ ...widthFull }}
                  type="dashed"
                  block
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                >
                  Add Question
                </Button>
                <Form.ErrorList errors={errors} style={{ margin: "10px" }} />
              </Form.Item>
            </>
          )}
        </Form.List>

        <Form.Item
          style={{ width: "100%", margin: "15px auto" }}
          wrapperCol={{ span: 4, offset: 10 }}
          labelCol={{ span: 0 }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%" }}
            loading={isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}

export default AddQuiz;
